'use strict';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {CurationEditorAbstract} from '../curation-editor-abstract';
import {WorkflowBarActionsCreatorService} from '../../../../shared/components/workflow-bar/services/workflow-bar-actions-creator.service';
import {DynamicModalLoaderService} from '../../../../layout/services/dynamic-modal-loader.service';
import {CurationActionCreatorService} from '../../../services/curation-action-creator.service';
import {CurationSettings} from '../../curation-dashboard/curation-setting';
import {PdfJsViewerComponent} from '../../../../../../node_modules/ng2-pdfjs-viewer';
import {get} from 'lodash';
import {PanelsService} from "@ispm/layout/services/panels.service";
import {CoreActionCreatorService} from "@ispm/core/services/core-action-creator.service";
import {TranslateService} from "@ngx-translate/core";
import {FormHandlerService} from "@ispm/dynamic-form/services/form-handler.service";
import {UserActionCreatorService} from '@ispm/user/services/user-action-creator.service';
import {DiagnosticOrderService} from '@ispm/dashboard/test/services/diagnostic-order.service';
import {ActivityService} from '@ispm/user/services/activity.service';
import {WorkflowConfigService} from "@ispm/workflow/services/workflow-config.service";
import {AuthenticationService} from '@ispm/user/services/authentication.service';
import {NotesService} from '@ispm/user/services/notes.service';
import {NotificationMessageService} from '@ispm/core/components/customise-notification/notifications-message.service';
import {ActivatedRoute, Router} from "@angular/router";
import {HttpInterceptorService} from "@ispm/core/services/http-interceptor.service";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'gen-curation-editor-report',
  templateUrl: 'curation-editor-report.component.html',
  styleUrls: ['curation-editor-report.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class CurationEditorReportComponent extends CurationEditorAbstract {
  @ViewChild('inlinePdfViewer', {static: false}) public inlinePdfViewer: PdfJsViewerComponent;
  public formName: string;
  pdfFileNotUploaded = true;
  showPdfViewer = false;

  constructor(authService: AuthenticationService,
    formHandler: FormHandlerService,
    public notificationMessageService: NotificationMessageService,
    workflowBarActionsCreatorService: WorkflowBarActionsCreatorService,
    modalLoader: DynamicModalLoaderService,
    activatedRoute: ActivatedRoute,
    panelService: PanelsService,
    curationActionCreatorService: CurationActionCreatorService,
    translateService: TranslateService,
    protected diagnosticOrderService : DiagnosticOrderService,
    notesService: NotesService,
    coreAC: CoreActionCreatorService,
    detector: ChangeDetectorRef,
    public userActionCreatorService: UserActionCreatorService,
    public activityService: ActivityService,
    workflowConfigService: WorkflowConfigService,
    _http: HttpInterceptorService,
    router: Router,
    routerManagerService: RouterManagerService) {
    super(authService, formHandler, notificationMessageService, workflowBarActionsCreatorService, modalLoader,
      activatedRoute, panelService, notesService, coreAC, curationActionCreatorService, translateService,
      diagnosticOrderService, userActionCreatorService, activityService, _http, router, undefined, detector, workflowConfigService, routerManagerService);
  }

  setInitParams() {
    this.formName = this.conf['ui']['forms']['editorForms']['formName'].name;
  }

  public getCurationKey(): string {
    let key: string;
    switch (this.curationType) {
      case CurationSettings.CURATION_PATHWAY:
        key = this.curationItem.curationData['content'] && this.curationItem.curationData['content']['title'] + ' ' +
          this.curationItem.curationData['content']['disease']['display'];
        break;

      case CurationSettings.CURATION_SUMMARY:
        key = this.curationItem.curationData['content'] && this.curationItem.curationData['content']['title'] + ' ' +
          this.curationItem.curationData['content']['center']['display'];
        break;
    }
    return key;
  }

  updateForm(form) {
    if (form) {

      // check if file was updated
      if (form.file && form.file.referenceId && (this.curationItem.curationData['content'] === undefined ||
          this.curationItem.curationData['content']['file'] === undefined ||
          this.curationItem.curationData['content']['file']['referenceId'] != form.file.referenceId)) {
        this.renderPdf(form);
      }

      // in case file was deleted
      if (form.file && form.file === 'deleted') {
        this.showPdfViewer = false;
        this.pdfFileNotUploaded = true;
      }

      for (const prop in form) {
        this.curationItem.curationData['content'][prop] = form[prop];
      }
      this.curationKey = this.getCurationKey();
    }
  }

  renderPdf(content: any) {
    if (get(content, 'file.referenceId')) {
      this.pdfFileNotUploaded = false;
      this.curationActionCreatorService.getDownloadedFile(content.file.referenceId).subscribe(
        (data => {
            /** Load the PDF file into the PDF viewer */
            this.inlinePdfViewer.pdfSrc = this.converBase64toBlob(data.base64Data);
            this.inlinePdfViewer.refresh();
            this.pdfFileNotUploaded = true;
	          this.showPdfViewer = true;
            this.detector.detectChanges();
          }
        ));
    }
  }

  validationEvent(valid) {
    this.isValid = valid;
  }

  postGetCurationItem() {
    this.renderPdf(this.curationItem.curationData['content']);
    this.isDataLoaded = true;
  }
  postUpdateCurationItem() {
    this.updateForm(this.curationItem.curationData['content']);
  }

  private converBase64toBlob(base64Content: string): Blob {
    const byteCharacters = atob(base64Content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    return new Blob([byteArray], { type: 'application/pdf'});
  }
}
